
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'

import InputAdornment from '@material-ui/core/InputAdornment'
import CheckCircle from '@material-ui/icons/CheckCircle'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import isString from "lodash/isString";

import {CASE_ID_HELPER_TEXT, MAX_CASE_ID_LENGTH} from "../../constants";

const styles = theme => ({
  fullWidth: {width: '100%'},
  hidden: {display: 'none'}
})

class SessionIdInput extends Component {
  constructor(props){
    super(props)

    this.state = {
      caseId: props.caseId || '',
      containsSpecialChar: false
    }
  }

  componentWillReceiveProps(nextProps) {
    const {caseId, isSuggestedCaseId, decisionId} = nextProps

    if(isSuggestedCaseId || decisionId !== this.props.decisionId) {
      this.setState({caseId})
      this.caseIdInputRef && this.caseIdInputRef.focus()
    }
  }

  renderHelpText = () => {
    const { t, errors } = this.props
    const { containsSpecialChar } = this.state

    if(containsSpecialChar) {
      return (
        <span>
          {t('Special characters are not allowed')}
        </span>
      )
    }

    if (errors.caseIdUniqueness) {
      return (
        <span>
          {t(CASE_ID_HELPER_TEXT)}
        </span>
      )
    }
  }

  render(){
    if(!this.props.visible)
      return null

    const { caseId, containsSpecialChar } = this.state
    const {classes, errors, t, caseIdPrefix, caseIdSuffix } = this.props
    const { getCaseIdEndAdornment, getCaseIdMaxLength, renderHelpText, onChange } = this

    const endAdornment = getCaseIdEndAdornment(caseIdSuffix)
    const inputLabelProps = (caseIdPrefix || caseIdSuffix) ?
      // shrink determines if floating label should be "shrunk" (floating) or not
      {shrink: true} : null
    const maxLength = getCaseIdMaxLength(caseIdPrefix, caseIdSuffix)

    return (
      <TextField
        className={classes.fullWidth}
        error={errors.caseIdUniqueness || containsSpecialChar}
        helperText={renderHelpText()}
        InputLabelProps={inputLabelProps}
        inputProps={{maxLength}} // eslint-disable-next-line react/jsx-no-duplicate-props
        InputProps={{
          endAdornment,
          startAdornment: caseIdPrefix ?
            <InputAdornment position="start">{caseIdPrefix}</InputAdornment> : null
        }}
        inputRef={el => ((this.caseIdInputRef = el) && el.focus())}
        label={t('Create New Case ID')}
        name="caseId"
        onChange={onChange}
        value={caseId}
      />
    )
  }

  onChange = (event) => {
    const caseId = event.target.value
    const format = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/
    const containsSpecialChar = format.test(event.target.value)
    this.setState({ caseId, containsSpecialChar }, () => {
      this.props.onChange(caseId, containsSpecialChar)
    })
  }

  getCaseIdEndAdornment = (caseIdSuffix) => {
    let endAdornment = null
    let adornmentChild = null
    const {caseId, containsSpecialChar } = this.state
    const {errors, isValidating} = this.props
    const hasValue = isString(caseId) && caseId.length

    if(isValidating) {
      adornmentChild = <CircularProgress size={15}/>
      // if isSuggestedCaseId we know this is a valid caseId (ignoring TOCTOU considerations)
    } else if((!errors.caseIdUniqueness && hasValue && !containsSpecialChar)) {
      adornmentChild = <CheckCircle color="secondary"/>
    }

    if(adornmentChild || caseIdSuffix) {
      endAdornment =
        <InputAdornment position="end">
          <span style={{marginRight: 10}}>{caseIdSuffix}</span>
          {adornmentChild}
        </InputAdornment>
    }
    return endAdornment
  }

  getCaseIdMaxLength(prefix, suffix) {
    let prefixLength = 0
    let suffixLength = 0
    if(isString(prefix)) {
      prefixLength = prefix.length
    }
    if(isString(suffix)) {
      suffixLength = suffix.length
    }
    return MAX_CASE_ID_LENGTH - prefixLength - suffixLength
  }
}

SessionIdInput.propTypes = {
  caseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  caseIdPrefix: PropTypes.string,
  caseIdSuffix: PropTypes.string,
  errors: PropTypes.object.isRequired,
  nextCaseId: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default compose(
  translate(),
  withStyles(styles)
)(SessionIdInput)



// WEBPACK FOOTER //
// ./src/components/setup/SessionIdInput.js